<template>
  <div :class="'form_btn_' + templateType">
    <a v-if="templateType == 'accept'" @click="submitData('agree')">本査定額に了承し、
      <br>振込を依頼する。
    </a>

    <div v-if="templateType == 'tel'">
      <a @click="submitData('tel')">相談のため、
        <br>電話連絡を希望する。
      </a>
    </div>
  </div>
</template>

<script>
const DEV = process.env.NODE_ENV === "development";
import { mapGetters, mapActions } from "vuex";
import router from "../router/";
export default {
  name: "form-btns",
  computed: {
    ...mapGetters(["ispc"])
  },
  methods: {
    ...mapActions(["saveInfo"]),
    submitData(type) {
      this.saveInfo(type);
    }
  },
  props: ["templateType"]
};
</script>

<style lang="scss" scoped>
.form_btn {
  &_accept {
    background: url(https://www.takakuureru.com/img/common/arrow_right_white.svg)
      right 20px top 50% #388e31 no-repeat;
    border: 1px solid #2f7137;
    border-radius: 8px;
    box-shadow: 0 2px 0 0 #2f7137, 0px 8px 10px rgba(0, 0, 0, 0.4),
      inset 0px 0px 20px 5px #33812d;
    color: #fff;
    display: inline-table;
    font-weight: bold;
    font-size: 22px;
    letter-spacing: 1px;
    line-height: 1.5;
    margin: 15px 30px 35px 0;
    text-align: center;
    width: 33%;
    &:hover {
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) inset;
      cursor: pointer;
    }
    a {
      color: #fff;
      font-weight: bold;
      display: block;
      padding: 20px;
    }
  }
  &_tel {
    background: url(https://www.takakuureru.com/img/common/arrow_right_white.svg)
      right 20px top 50% #f3840d no-repeat;
    border: 1px solid #b55f01;
    border-radius: 8px;
    box-shadow: 0 2px 0 0 #b55f01, 0px 8px 10px rgba(0, 0, 0, 0.4),
      inset 0px 0px 20px 5px #e87c07;
    color: #fff;
    display: inline-table;
    font-weight: bold;
    font-size: 22px;
    letter-spacing: 1px;
    line-height: 1.5;
    margin: 15px 0 35px 0;
    text-align: center;
    width: 33%;
    &:hover {
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) inset;
      cursor: pointer;
    }
    a {
      color: #fff;
      font-weight: bold;
      display: block;
      padding: 20px;
    }
  }
}
@media screen and (min-width: 601px) and (max-width: 959px) {
  .form_btn_accept {
    background: url(https://www.takakuureru.com/img/common/arrow_right_white.svg)
      right 10px top 50% #388e31 no-repeat;
    font-size: 18px;
  }
  .form_btn_tel {
    background: url(https://www.takakuureru.com/img/common/arrow_right_white.svg)
      right 10px top 50% #f3840d no-repeat;
    font-size: 18px;
  }
}
@media screen and (max-width: 600px) {
  .form_btn_accept {
    background: url(https://www.takakuureru.com/img/common/arrow_right_white.svg)
      right 7px top 50% #388e31 no-repeat;
    font-size: 18px;
    margin-right: 0;
    margin-bottom: 15px;
    width: 88%;
    a {
      padding: 15px 17px 15px 8px;
    }
  }
  .form_btn_tel {
    font-size: 18px;
    width: 88%;
    a {
      padding: 15px 17px 15px 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormBtns.vue